import {
  Abas,
  Alice,
  Bradesco,
  CarePlus,
  Itau,
  Omint,
  Porto,
  Sami,
  Kipp,
  Sulamerica,
  Unimed,
  type SVGIconProps,
} from "@repo/icons";
import type { FunctionComponent } from "react";

const INSURANCE_PROVIDER_ICONS: Record<
  number,
  FunctionComponent<SVGIconProps> | undefined
> = {
  3: Bradesco,
  5: CarePlus,
  9: Itau,
  12: Omint,
  14: Porto,
  15: Unimed,
  16: Sulamerica,
  25: Unimed,
  27: Kipp,
  28: Alice,
  29: Sami,
  30: Abas,
  32: CarePlus,
};

interface HealthInsuranceInfoProps {
  healthInsuranceName?: string | null;
  healthInsuranceCode?: number | null;
}

export const HealthInsuranceInfo = ({
  healthInsuranceName,
  healthInsuranceCode,
}: HealthInsuranceInfoProps): JSX.Element | null => {
  if (!healthInsuranceCode) {
    return null;
  }

  const HealthInsuranceIcon = INSURANCE_PROVIDER_ICONS[healthInsuranceCode];

  return (
    <div className="flex flex-row items-center gap-2">
      <p>{healthInsuranceName ?? "-"}</p>
      {HealthInsuranceIcon ? (
        <HealthInsuranceIcon size={24} className="text-medium-500" />
      ) : null}
    </div>
  );
};
